import React from 'react';
import BackgroundAudio from './BackgroundAudio';
import Header from './Header';
import Intro from './Intro';
import Question1 from './Question1';
import Question2 from './Question2';
import Question3 from './Question3';
import Question4 from './Question4';
import Question5 from './Question5';
import Question6 from './Question6';
import Question7 from './Question7';
import Question8 from './Question8';
import Question9 from './Question9';
import Question10 from './Question10';
import OrientationOverlay from './orientation-overlay';
import End from './End';

// helpers
import gameStates from '../helpers/gameState';

// custom hooks
import useGame from '../hooks/useGame';

// scss
import '../scss/style.scss';

// main app
const App = () => {
  const { REACT_APP_LANGUAGE } = process.env;
  const { gameState } = useGame();

  return (
    <>
      <BackgroundAudio />
      <Header />      
      <OrientationOverlay />
      {gameState === gameStates.INTRO && <Intro />}
      {gameState === gameStates.QUESTION_1 && <Question1 />}
      {gameState === gameStates.QUESTION_2 && <Question2 />}
      {gameState === gameStates.QUESTION_3 && <Question3 />}
      {gameState === gameStates.QUESTION_4 && <Question4 />}
      {gameState === gameStates.QUESTION_5 && <Question5 />}
      {gameState === gameStates.QUESTION_6 && <Question6 />}
      {gameState === gameStates.QUESTION_7 && <Question7 />}
      {gameState === gameStates.QUESTION_8 && <Question8 />}
      {gameState === gameStates.QUESTION_9 && <Question9 />}
      {gameState === gameStates.QUESTION_10 && <Question10 />}
      {gameState === gameStates.ENDED && <End />}
    </>
  );
};

export default App;
